module.exports = __webpack_public_path__ + "static/media/manager-b-4.78b174bc.png";